export function popupBio() {
    $(".popup-opener").on("click", function (e) {
        $("body").addClass("popup-open");
        var team_id = $(this).attr('data-team-id');
        $('.popup-bio .photo , .popup-bio .info').remove();
        $.ajax({
            url: ajaxvars.ajaxurl,
            data: {
                action: "load_team_popup",
                team_id: team_id
            },
            type: "POST",
            success: function success(response) {
                if (response) {
                    $(".popup-bio .content-bio").html(response.content);
                    if ($(".jcf-scrollable").length && $("body").hasClass("no-touch")) {
                        jcf.replaceAll();
                    }
                }
            }
        });
        e.preventDefault();
    });

    $(".close-popup").on("click", function (e) {
        $("body").removeClass("popup-open");
        e.preventDefault();
    });

    $(document).keyup(function () {
        if (event.keyCode === 27) {
            $("body").removeClass("popup-open");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/popupBio.js